<template>
	<button class="btn btn-link btn-circle btn-delete" @click="e => { e.preventDefault(); onClick(e); }"><i class="fa fa-times"></i></button>
</template>

<script>
export default {
	props: {
		onClick: {
			type: Function,
			required: true
		},
	}
}
</script>

<style lang="less" scoped>
	.btn-link {
		font-weight: normal;
	}
	.btn-link:not(:hover) {
		color: #333;
	}
	.btn-link:active {
		box-shadow: none;
	}
</style>
